import EventBase from './EventBase'
import EventID from './EventID'
import EventTextDifExBase from './EventTextDifExBase'

/**
 * 1011 剧情分歧EX2
 */
export default class EventTextDifEx2 extends EventTextDifExBase {
  TIME_END = 'ORGTIMEOVER|结束项'
  perSetList: PersenalSetClass[] = []
  showConditionList: string[] = []

  /**
   * 构造函数
   * @param param 传进来的剧情分歧项
   */
  constructor(param?: string[]) {
    super()
    if (param) {
      const newtemp = param.filter((t) => t != this.TIME_END)
      this.perSetList = new Array<PersenalSetClass>()
      this.showConditionList = new Array<string>()
      this.Parameter = new Array(newtemp.length * 3 + 15) //判断是否需要添加结束项
      this.ChoiceText = newtemp
      for (let i = 0; i < this.InitialParam.length; i++) {
        this.Parameter[i] = this.InitialParam[i]
      }
      this.bgStr = ['0', '', '0', '0', '0']
      for (let i = 8; i < this.bgStr.length + 8; i++) {
        this.Parameter[i] = this.bgStr[i - 8]
      }
    } else {
      this.perSetList = new Array<PersenalSetClass>()
      this.showConditionList = new Array<string>()
    }
  }

  setLocalesParam(indexes: number[]): void {
    indexes = []
    const choiceTexts = this.ChoiceText
    let index = 15
    for (let i = 0; i < choiceTexts.length; i++){
      indexes.push(index)
      index += 3
    }
  }

  /// <summary>
  /// 背景图选项
  /// </summary>
  public bgStr: string[] = []
  /// <summary>
  /// 剧情分歧
  /// </summary>
  Code = EventID.TextDifEx2
  // #region 数据绑定的都在这里
  /// <summary>
  /// 分歧数量
  /// </summary>
  get DifCount() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set DifCount(value) {
    this.Parameter![0] = value.toString()
  }

  /// <summary>
  /// 是否开启底图
  /// </summary>
  get IsMapOpen() {
    return this.Parameter![9] == '1'
  }
  set IsMapOpen(value) {
    this.Parameter![9] = value ? '1' : '0'
  }
  /// <summary>
  /// 图片文件名（UI文件夹下，如cg.png)
  /// </summary>
  get ImageName() {
    return this.Parameter?.[10] ?? ''
  }
  set ImageName(value) {
    this.Parameter![10] = value
  }
  /// <summary>
  /// 底图绝对X
  /// </summary>
  get AbsMapX() {
    return parseInt(this.Parameter?.[11] ?? '')
  }
  set AbsMapX(value) {
    this.Parameter![11] = value.toString()
  }
  /// <summary>
  /// 底图绝对Y
  /// </summary>
  get AbsMapY() {
    return parseInt(this.Parameter?.[12] ?? '')
  }
  set AbsMapY(value) {
    this.Parameter![12] = value.toString()
  }
  /// <summary>
  /// 底图出现效果
  /// </summary>
  get MapShowEffect() {
    return this.Parameter?.[13] ?? ''
  }
  set MapShowEffect(value) {
    this.Parameter![13] = value
  }
  /// <summary>
  /// 是否开启每项自定义(1-开 0-关)
  /// </summary>
  get IsCustomOpen() {
    return this.Parameter?.[14] == '1'
  }
  set IsCustomOpen(value) {
    this.Parameter![14] = value ? '1' : '0'
  }

  /// <summary>
  /// 分歧内容
  /// </summary>
  get ChoiceText() {
    const list = new Array<string>()
    for (let i = 15; i < this.Parameter!.length; i += 3) {
      list.push(this.Parameter![i])
    }
    return list
  }
  set ChoiceText(value) {
    let j = 0
    for (let i = 15; i < this.Parameter!.length; i += 3) {
      this.Parameter![i] = value[j]
      j++
    }
    // TODO:
    // if(this.PropertyChanged != null)
    // {
    // 	this.PropertyChanged.Invoke(this, new PropertyChangedEventArgs("ChoiceText"));
    // }
  }

  /// <summary>
  /// 选项出现条件
  /// </summary>
  get ChoiceShowCondition() {
    return this.showConditionList
  }
  set ChoiceShowCondition(value) {
    this.showConditionList = []
    let j = 0
    for (let i = 16; i < this.Parameter!.length; i += 3) {
      this.Parameter![i] = value[j]
      this.showConditionList.push(value[j])
      j++
    }
  }

  public SetShowConditionInit() {
    this.showConditionList = []
    for (let i = 16; i < this.Parameter!.length; i += 3) {
      this.showConditionList.push(this.Parameter![i])
    }
  }
  /// <summary>
  /// 个性设置集合
  /// </summary>

  get PersonalSet() {
    return this.perSetList
  }
  set PersonalSet(value) {
    this.perSetList = []
    this.Parameter[14 + value.length * 3] = ""
    let j = 0
    for (let i = 17; i < this.Parameter!.length; i += 3) {
      this.Parameter![i] =
        this.Parameter![14] == '0'
          ? ''
          : value[j] == null
          ? ''
          : value[j].TotalString
      this.perSetList.push(new PersenalSetClass(this.Parameter![i]))
      j++
    }
  }

  public endItem: string = ''

  get EndItem() {
    return this.endItem
  }
  set EndItem(value) {
    const tempStr = [...this.Parameter!]
    this.Parameter = []
    for (let i = 0; i < tempStr.length; i++) {
      this.Parameter[i] = tempStr[i]
    }
    this.Parameter[this.Parameter.length - 1] = value
    this.endItem = value
    this.Parameter[this.Parameter.length - 1] = value
  }

  public GetParameterStr() {
    return this.Parameter
  }

  public SetPersonlInit() {
    this.perSetList = []
    let j = 0
    for (let i = 17; i < this.Parameter!.length; i += 3) {
      this.perSetList.push(new PersenalSetClass(this.Parameter![i]))
      j++
    }
  }
}
export class PersenalSetClass {
  public SetParams: string[] = []
  pars: string[]
  public constructor(parstr = '') {
    this.SetParams = ['0', '0', '0', '1', '0', '0']
    this.pars = parstr.split(',')
    if (this.pars != null && this.pars.length == 6) {
      for (let i = 0; i < this.pars.length; i++) {
        this.SetParams[i] = this.pars[i]
      }
    }
  }

  get TotalString() {
    if (this.SetParams != null) {
      return (
        (this.SetParams[0] ?? '0') +
        ',' +
        (this.SetParams[1] ?? '0') +
        ',' +
        (this.SetParams[2] ?? '0') +
        ',' +
        (this.IsCenter ? '1' : '0') +
        ',' +
        (this.SetParams[4] ?? '0') +
        ',' +
        (this.SetParams[5] ?? '0')
      )
    }
    return ''
  }
  set TotalString(value) {
    if (this.SetParams == null) {
      this.SetParams = ['0', '0', '0', '0', '0', '0']
    }
    this.pars = value.split(',')
    if (this.pars != null && this.pars.length == 6) {
      for (let i = 0; i < this.pars.length; i++) {
        this.SetParams[i] = this.pars[i]
      }
    }
  }

  // #region 数据绑定的都在这里
  /**
   * 按钮index
   */
  get ButtonIndex() {
    return parseInt(this.SetParams[0])
  }
  set ButtonIndex(value) {
    this.SetParams[0] = value.toString()
  }

  /**
   * 按钮绝对X
   */
  get AbsButtonX() {
    return parseInt(this.SetParams[1])
  }
  set AbsButtonX(value) {
    this.SetParams[1] = value.toString()
  }
  /**
   * 按钮绝对Y
   */
  get AbsButtonY() {
    return parseInt(this.SetParams[2])
  }
  set AbsButtonY(value) {
    this.SetParams[2] = value.toString()
  }

  /**
   * 是否居中
   */
  get IsCenter() {
    return this.SetParams[3] == '1' || this.SetParams[3] === 'true'
  }
  set IsCenter(value) {
    this.SetParams[3] = value ? '1' : '0'
  }

  /**
   * 文字相对X
   */
  get RETextX() {
    return parseInt(this.SetParams[4])
  }
  set RETextX(value) {
    this.SetParams[4] = value.toString()
  }

  /**
   * 文字相对Y
   */
  get RETextY() {
    return parseInt(this.SetParams[5])
  }
  set RETextY(value) {
    this.SetParams[5] = value.toString()
  }


}
// #endregion
